import type { DirectedPath, FleetEntry, Alignment } from './contracts.js';
import { alignmentAt, pointAlong } from './track.js';
export interface CarPose { index: number; centerMeters: number; position: [number,number]; heading: number; alignment: Alignment }
export function placeConsist(path: DirectedPath, target: number, fleet: FleetEntry, pitchMeters: number): CarPose[] {
  const length = path.sMeters.at(-1) ?? 0, consistLength = fleet.cars * pitchMeters;
  if (length < consistLength) throw new Error(`path length ${length} is shorter than consist ${consistLength}`);
  const head = Math.max(consistLength, Math.min(length, target));
  return Array.from({ length: fleet.cars }, (_, index) => {
    const centerMeters = head - (index + 0.5) * pitchMeters, sample = pointAlong(path, centerMeters);
    return { index, centerMeters, position: sample.geo, heading: sample.heading, alignment: alignmentAt(path.runs, centerMeters) };
  });
}
